export default __webpack_public_path__ + "slider-arrow.svg";